import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/5 mt-24" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 grid gap-6 md:grid-cols-[2fr_1fr] text-xs text-slate-500 leading-relaxed">
      <p>
        21+ only. BonusVault is an independent information service and is not affiliated with any casino. Offers change frequently —
        always confirm terms on the operator's site. Sweepstakes and real-money casino availability varies by state. Play responsibly.
        Gambling problem? Call 1-800-GAMBLER.
      </p>
      <div className="flex md:justify-end gap-5">
        <a href="https://www.ncpgambling.org" target="_blank" rel="noreferrer" className="hover:text-slate-300" data-testid="footer-help-link">Responsible Gambling</a>
        <Link to="/admin/login" className="hover:text-slate-300" data-testid="footer-admin-link">Admin</Link>
      </div>
    </div>
  </footer>
);
